import { toast } from "../components/ui/use-toast";

/**
 * Wraps an API call and handles 403 errors with toast notifications
 * @param apiCall - The API call function to execute
 * @returns The result of the API call if successful
 * @throws The error if it's not a 403 error
 */
export async function withErrorHandling<T>(apiCall: () => Promise<T>, onUnauthed?: () => void): Promise<T> {
    try {
        return await apiCall();
    } catch (error: any) {
        if (error.response?.status === 403) {
            toast({
                title: "Access Denied",
                description: error.response?.data?.error || "You don't have permission to perform this action",
                variant: "destructive",
                className: "text-textlight ",
            });
            if (onUnauthed) {
                onUnauthed()
            }
        }
        throw error;
    }
} 